import superagent from 'superagent'

import config from '../../config'
import auth from '../../auth'

export default {
    exist,
    create,
}

async function exist(auth_type) {
    const res = await superagent
        .get(config.url_api + '/customer/exist')
        .query(auth.getAuthQs(auth_type))

    // exists
    if (res.status == 200) {
        return true
    }

    // good to be new customer
    if (res.status == 204) {
        return false
    }

    // invalid status code
    throw new Error('There was an error with your login. Please try again later')
}

async function create(opt) {
    const res = await superagent
        .post(config.url_api + '/customer')
        .type('form')
        .query(auth.getAuthQs())
        .send({
            email: opt.email,
            name: opt.name,
            plan_id: opt.plan,
            card_token: opt.card_token,
        })

    if (res.status != 201) {
        throw new Error('There was an error with your checkout. Please try again later')
    }

    return true
}